export default class UtilsService {

    constructor() {
        this.baseURL = window.baseURL;
        this.language = window.datepickerLang;
    }

    getApiPath(path) {
        return this.baseURL + encodeURI(path);
    }

    setCallCenter(citizenships) {
        let isForForeigners = function(citizenships) {
          return !($.inArray(citizenships[0], window.statics.eftaCitizenships) !== -1 || $.inArray(citizenships[1], window.statics.eftaCitizenships) !== -1);
        };

        $('.callcenter').each(function () {
            if ($('#sidebarMain .callcenter').length > 1) {
                if ($(this).data('for_foreigner') === isForForeigners(citizenships)) {
                    $(this).show();
                }
                else {
                    $(this).hide();
                }
            }
        });
    }
}
